// src/api/api.js
import axios from 'axios';
import { getToken, getTokenExpiry, logout, clearStoredAuth } from './auth';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.apexacademiccentre.co.za/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 10000,
});

const ensureHeaders = (config) => {
  if (!config.headers) config.headers = {};
  return config.headers;
};

api.interceptors.request.use(
  (config) => {
    const headers = ensureHeaders(config);
    const token = getToken?.();
    const expiresAt = getTokenExpiry?.();

    if (token) {
      if (expiresAt && expiresAt <= Date.now()) {
        clearStoredAuth?.();
      } else {
        headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (!error.response) {
      toast.error('Network error: Please check your connection.');
      return Promise.reject(error);
    }
    const { status, data } = error.response;
    const method = (error?.config?.method || '').toLowerCase();

    if (status === 404 && method === 'get') {
      return Promise.reject(error);
    }

    const msg = (data?.message || data?.error || '').toString().toLowerCase();
    const looksLikeEmpty = msg.includes('no ') && msg.includes('found');

    if (status === 401) {
      toast.error('Session expired. Please login again.');
      logout?.({ redirect: true });
    } else if (status >= 500) {
      toast.error('Server error. Please try again later.');
    } else if (status >= 400) {
      if (!looksLikeEmpty) {
        toast.error(data?.message || data?.error || 'An error occurred.');
      }
    }
    return Promise.reject(error);
  }
);

export const getLadUrl = (meetingID, report) =>
  api.get('/bbb/lad-url', { params: { meetingID, ...(report ? { report } : {}) } });

export default api;
